import React from 'react';
import { Box, Button } from '@mui/material';
import { useUntypedTranslation } from '../../../hooks/useUntypedTranslation';

export function AdvisoryChapterLink({
  label,
  chapter,
  onClick,
  inheritColor = false,
}: {
  label: string;
  chapter?: number;
  onClick?: () => void;
  inheritColor?: boolean;
}) {
  const { t } = useUntypedTranslation();
  const position = chapter === undefined ? null : String(chapter).padStart(2, '0');
  const content = (
    <>
      {position ? (
        <Box
          component="span"
          aria-hidden="true"
          sx={theme => ({
            fontFamily: theme.visualPrimitives.monoStack,
            fontSize: 11,
            lineHeight: '20px',
            minWidth: 26,
            textAlign: 'center',
            border: '1px solid',
            borderRadius: 0.5,
            flexShrink: 0,
          })}
        >
          {position}
        </Box>
      ) : null}
      <Box component="span" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
        {label}
      </Box>
    </>
  );
  const ariaLabel = position
    ? `${t('advisory:brief.chapterMarker', { position })}: ${label}`
    : undefined;
  return onClick ? (
    <Button
      size="small"
      onClick={onClick}
      aria-label={ariaLabel}
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'flex-start',
        gap: 1.25,
        textTransform: 'none',
        textAlign: 'left',
        justifyContent: 'flex-start',
        paddingX: 0,
        color: inheritColor ? 'inherit' : undefined,
      }}
    >
      {content}
    </Button>
  ) : (
    <Box
      aria-label={ariaLabel}
      sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25, fontSize: 13 }}
    >
      {content}
    </Box>
  );
}
